import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import * as actions from '../action';
import * as c from '../constant';
import AssessmentLevelsModal from '../modals/AssessmentLevelsModal';

function AssessmentLevelContent({
  handleEdit,
  handleRemove,
  assessmentLevelId,
  showData,
  dataInfo,
  ordinanceRevisionId
}) {

  const setModal = useContext(ModalContext);

  useEffect(() => {
    if (_.isEmpty(assessmentLevelId)) return;
    showData(assessmentLevelId, ordinanceRevisionId);
  }, []);

  useEffect(() => {
    if (_.isEmpty(assessmentLevelId)) return;
    showData(assessmentLevelId, ordinanceRevisionId);
  }, [assessmentLevelId]);

  const assessmentLevelInfo = _.get(dataInfo, 'attributes.assessment_level_rates');

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <AssessmentLevelsModal type="NEW" ordinanceRevisionId={ordinanceRevisionId} />,
      title: 'Add Structural Type',
      modalSize: 'modal-lg',
      modalContentSize: 'custom-size'
    });
  };

  return (
    <>
      <div className="row mb-3">
        <div className="ml-auto">
          <button
            type="button"
            onClick={handleAddModal}
            className="btn btn-assessment font-weight-bold"
          >
            <i className="fas fa-plus" /> Add Assessment Level
          </button>
        </div>
      </div>
      <div className="ml-3 card right-section">
        <div className="p-3">
          <div className="d-flex mb-3">
            <div className="col-8 mt-2">
              <span className="font-weight-bold"> Information </span>
            </div>
          </div>
          <hr />
          {!_.isEmpty(dataInfo) ? (
            <React.Fragment>
              <div className="ml-3 row my-3 mx-0">
                <table className="css-table table table-sm table-striped table-hover">
                  <thead className="table-header">
                    <tr>
                      <td width="200"><b>Over</b></td>
                      <td width="200"><b>Not Over</b></td>
                      <td width="200"><b>Assessment Level</b></td>
                      <td width="200"><b>Ordinance Revision</b></td>
                      <td style={{ textAlign: 'center' }} width="200"><span className="font-weight-bold" style={{ marginLeft: 100 }}>Actions</span></td>
                    </tr>
                  </thead>
                  <tbody>
                    {_.isEmpty(assessmentLevelInfo) ? (
                      <tr className="w-100">
                        <td colSpan="5" className="text-center border-top p-4 text-muted">
                          This Section is Empty
                        </td>
                      </tr>
                    ) : (
                      assessmentLevelInfo.map(item => (
                        <tr key={item.id}>
                          <td className="history-color">{_.get(item, 'over')}</td>
                          <td className="history-color">{_.get(item, 'not_over') || ''}</td>
                          <td className="history-color">{_.get(item, 'assessment_level') || ''}</td>
                          <td className="history-color">{_.get(item, 'ordinance_name')}</td>
                          <td style={{ textAlign: 'right' }}>
                            <div className="d-flex">
                              <button type="button" className="btn-blank ml-auto" onClick={handleEdit(item)}>
                                <i className="far fa-edit icon-edit" />
                              </button>
                              <button type="button" className="btn-blank" onClick={handleRemove(item)}>
                                <i className="far fa-trash-alt icon-delete" />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </React.Fragment>
          ) : (
            <div className="d-flex align-items-center justitfy-content-center h-100">
              <div className="text-center mx-auto py-4">
                <img
                  src={emptyStateImage}
                  className="img-responsive image-wrapper mb-4 mt-3"
                  alt="Empty State"
                />
                <p className="emp-title mb-0"> No Item Found </p>
              </div>
            </div>
          )
          }
        </div>
      </div>
    </>
  );
}

AssessmentLevelContent.propTypes = {
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  handleRemove: PropTypes.instanceOf(Function).isRequired,
  showData: PropTypes.instanceOf(Function).isRequired,
  dataInfo: PropTypes.instanceOf(Object).isRequired,
  assessmentLevelId: PropTypes.string.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  dataInfo: _.get(api, `${c.SHOW_DATA}.item`) || {},
  assessmentLevelId: _.get(match, 'params.assessmentLevelId') || '',
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(AssessmentLevelContent);
